import jwtDecode, { JwtPayload } from "jwt-decode";
import { DateTime } from "luxon";

export class Session implements SessionData {
    private readonly data: SessionData;

    constructor(data: SessionData) {
        this.data = data;
    }

    get authToken(): string {
        return this.data.authToken;
    }

    get ttlInSeconds(): number {
        return this.data.ttlInSeconds;
    }

    get isValid(): boolean {
        const token = this.authToken;

        if (!token) {
            return false;
        }

        const decoded = jwtDecode<JwtPayload>(token);

        if (!decoded.exp) {
            return false;
        }

        const expirationDate = DateTime.fromSeconds(decoded.exp);
        const now = DateTime.now();

        return now.toSeconds() <= expirationDate.toSeconds();
    }
}

export interface SessionData {
    readonly authToken: string;
    readonly ttlInSeconds: number;
}
